export default __webpack_public_path__ + "static/media/email_icon.d8492012.svg";